export type Validator = (value: string) => string;

export const noValidation: Validator = () => "";

export const required: Validator = (value) => {
  return !value.trim() ? "Dit veld is verplicht." : "";
}

export const isValidString: Validator = (value) => {
  return value.length > 100 ? "Maximum 100 karakters." : "";
};

export const isValidNumber: Validator = (value) => {
  const num = parseFloat(value);
  return num > 9999 ? "Maximum getal is 9999" : "";
};

export const isEmail: Validator = (value) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return !emailRegex.test(value) ? "Ongeldig email adres." : "";
};

export const isPhone: Validator = (value) => {
  const phoneRegex = /^(?:\+31 |0)6[\s-]?\d{8}$/;
  return !phoneRegex.test(value) ? "Ongeldig telefoon nummer." : "";
};

export const isPrice: Validator = (value) => {
  const priceRegex = /^\d+(\.\d{1,2})?$/;
  return (!priceRegex.test(value.trim())) ? "Ongeldige prijs." : "";
};

export const maxLength = (max: number): Validator => (value) =>
  value.length > max ? `Maximum ${max} karakters.` : "";

export const isPostcodeFormat: Validator = (value) => {
  const normalized = value.replace(/\s+/g, "").toUpperCase();
  return /^[1-9][0-9]{3}[A-Z]{2}$/.test(normalized) ? "" : "Ongeldige postcode.";
};

export const isPostcodeInRidderkerk: Validator = (value) => {
  const digits = value.replace(/\D/g, "");
  if (digits.length < 4) return "";
  const first4 = parseInt(digits.slice(0, 4), 10);
  return first4 >= 2981 && first4 <= 2989 ? "" : "Postcode niet in Ridderkerk.";
};

export const isStreetAddress: Validator = (value) => {
  return /\D+\s+\d+/.test(value) ? "" : "Voer straat en huisnummer in (bijv. Straat 12).";
};

export const isImage: Validator = (value) => {
  const IMAGE_TYPES = ["jpg", "png", "jpeg", "webp"];
  const ext = value.split(".").pop()?.toLowerCase() ?? "";

  console.log("ext", ext);
  if (IMAGE_TYPES.includes(ext)) {
    return "";
  } else {
    return "Upload is geen afbeelding.";
  }
};

// put most important or generic validators first, so those will show first to the user
export const combineValidators = (...validators: Validator[]): Validator => (value) => {
  for (const validate of validators) {
    const error = validate(value);
    if (error) return error;
  }
  return "";
};